@if (message) {
  <div class="wrapper">
    <span class="message">{{message}}</span>@if (showUnit) {
    <span class="unit">&nbsp;{{unit}}</span>
  }
</div>
}
